import { createSlice } from '@reduxjs/toolkit';

export const calendarCustomHourSliceKey = 'calendarCustomHourState';

const initialState = {
  customHour: { startHour: '', endHour: '' }
};

const { actions, reducer } = createSlice({
  name: calendarCustomHourSliceKey,
  initialState,
  reducers: {
    // Acción para establecer customHour
    setCustomHour(state, { payload }) {
      state.customHour = payload;
    }
  }
});

// Definir una función base selector
const baseSelector = (state) => state[calendarCustomHourSliceKey];

// Selector para obtener customHour (sin necesidad de pasar el state explícitamente)
export const getCustomHour = (state) => baseSelector(state).customHour;

// Exportaciones
export const calendarCustomHourReducer = reducer;
export const { setCustomHour } = actions;
